module.exports = __webpack_public_path__ + "img/cotentsuite12.c6789453.png";